import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// Core-local copy of the app cn() (see frontend/src/lib/utils.ts). The custom
// fontSize utilities must stay registered in the font-size class group —
// otherwise tailwind-merge classifies unknown `text-*` classes as text COLOR,
// and `cn("text-btn-compact", "text-chat-text")` would drop the size class
// instead of keeping both. When the CP-23 preset contract lands, this class
// group list becomes part of the preset.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": ["text-body-reduced", "text-btn-compact"],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
